import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-form-validates';
import { renderEngine, template } from '@iyunbao/cr-engine';
import { Button, Modal, Toast } from 'zarm';

import PopupBottom from '../../popupBottom';
import { isObject, deepAsset, deepCopy } from '../../utils/tools';
import { ObjectAnyProps } from '../../utils/type';
import fetchAPI from '../../utils/fetchAPI';
import config from '../../config';
import { RadioPersonProps, RadioRadioPersonState } from './types';
import { getSelectedValues, getItemLabel, getNames } from './_util';

const createForm = Form.create;

class addPopup extends PureComponent<RadioPersonProps, RadioRadioPersonState> {
  static propTypes = {
    prefixCls: PropTypes.string,
  };

  static defaultProps = {
    prefixCls: 'crm-radio-person',
  };

  state = {
    visible: true,
    title: '',
    footer: [],
    isEdit: false,
    current: 0,
    selectedValues: getSelectedValues(this.props),
    popupData: {},
  };

  // get form name
  names = getNames(this.props);

  static getDerivedStateFromProps(nextProps: RadioPersonProps, state: RadioRadioPersonState) {
    if ('value' in nextProps && !deepAsset(nextProps.value, state.prevValue)) {
      return {
        prevValue: nextProps.value,
        selectedValues: getSelectedValues(nextProps),
      };
    }

    return null;
  }

  // 触发value，联动需要
  onChange = (item: any) => {
    const { refresh = false } = item;
    const { form, _crengine = {} } = this.props;
    const { childrens } = _crengine;
    let flag = false;

    if (
      refresh
      && childrens
      && childrens[0]
      && childrens[0].childrens
    ) {
      const child = childrens[0].childrens;
      let fetchParams = {
        url: `${config.iybtm.host}/sale/v4/layout/special.json`,
        method: 'POST',
        data: {},
      };

      // 后端添加试算因子 widget:"hidden"并且有fetch 属性
      child.forEach((ichild:any) => {
        if (
          ichild
          && ichild.widget === 'hidden'
          && ichild.fetch
        ) {
          flag = true;
          fetchParams = Object.assign(fetchParams, ichild.fetch);
        }
      });

      if (!flag) {
        return console.error('重新渲染受益人需要hidden因子');
      }
      setTimeout(() => {
        // 获取form表单的值
        if (form && form.getFieldsValue) {
          const values = form.getFieldsValue();
          fetchParams.data = Object.assign(fetchParams.data, values);
        }
        fetchAPI
          .fetchResult(fetchParams)
          .then((res: any) => {
            const { message, code, result } = res;
            if (+code === 0 && result) {
              this.setState({
                popupData: result,
              });
            } else {
              message && Toast.show(message);
            }
          })
          .catch((message: string) => {
            message && Toast.show(message || '接口异常');
          });
      }, 0);
    }
  };

  onSubmit(item) {
    const { isEdit, current, selectedValues } = this.state;
    const { form, _crengine } = this.props;
    const { action } = item || {};
    const { type } = action || {};

    switch (type) {
      // 取消
      case 'cancel':
        this.onClose();
        break;
      default:
        if (form) {
          form.validateFields((errors, values) => {
            if (errors) {
              return false;
            }

            // 编辑模式
            if (values && selectedValues && Array.isArray(selectedValues)) {
              if (isEdit) {
                selectedValues[current] = values;
              } else {
                selectedValues.push(values);
              }
            }
            // set form value
            if (_crengine && _crengine.form) {
              setTimeout(() => {
                _crengine.form.setFieldsValue({
                  [`${this.names}[list]`]: selectedValues,
                });
              }, 0);
            }

            this.setState({
              visible: false,
              isEdit: false,
              selectedValues,
            });
          });
        }
        break;
    }
  }

  // 关闭层
  onClose() {
    this.setState({ visible: false });
  }

  // 删除受益人
  onDelete(index: number, event) {
    const { selectedValues } = this.state;

    event.stopPropagation();

    if (selectedValues && Array.isArray(selectedValues) && selectedValues.length) {
      const onOk = () => {
        selectedValues.splice(index, 1);
        this.forceUpdate();
      };

      Modal.confirm({
        title: `删除受益人${index + 1}`,
        onOk,
      });
    }
  }

  onEdit(index: number) {
    const { selectedValues } = this.state;

    if (selectedValues && Array.isArray(selectedValues) && selectedValues.length) {
      const values = selectedValues[index];

      this.setState({
        isEdit: true,
        current: index,
      });

      this.openPopup(values);
    }
  }

  // 打开层
  openPopup(values?: ObjectAnyProps) {
    const { _crengine } = this.props;
    const { childrens } = _crengine || {};

    if (!(childrens && Array.isArray(childrens) && childrens.length)) {
      console.error('未配置子级列表');
      return false;
    }

    const { widget, name, wprops, childrens: subChildrens } = childrens[0];
    const { label, footer } = wprops || {};

    const popupData = {
      widget: (widget || 'person-add-popup'),
      name,
      childrens: deepCopy(subChildrens),
    };

    // 编辑模块
    if (values && popupData.childrens) {
      popupData.childrens.map((item) => {
        if (item && item.dataBind && typeof values[item.dataBind] !== 'undefined') {
          item.defaultValue = values[item.dataBind];
        }

        return item;
      });
    }

    this.setState({
      visible: true,
      title: label,
      footer,
      popupData,
    });
  }

  renderComponents() {
    const { popupData } = this.state;
    // popup form
    const { form, _crengine } = this.props;
    const { components } = _crengine || {};

    if (!(popupData && Object.keys(popupData).length)) {
      return null;
    }

    const options = {
      components,
      form,
      // 自动去除前后空格
      valueTrim: true,
      storeId: 'addPopupForm',
    };

    const events = {
      onChange: this.onChange,
    };

    return renderEngine(popupData, options, events);
  }

  renderFooter() {
    const { footer } = this.state;

    if (footer && Array.isArray(footer) && footer.length) {
      return footer.map((item, key) => {
        const { label, theme } = item;

        return (
          <Button
            block
            theme={theme}
            shape="rect"
            className="item-button"
            key={`item_${key}`}
            size="lg"
            onClick={() => this.onSubmit(item)}
          >
            {label}
          </Button>
        );
      });
    }

    return null;
  }

  renderPopup() {
    const { visible, title, popupData } = this.state;
    const { prefixCls } = this.props;

    if (!(visible && popupData && Object.keys(popupData).length)) {
      return null;
    }

    return (
      <PopupBottom
        visible={visible}
        title={title}
        className={`${prefixCls}-popup`}
        footer={this.renderFooter()}
        onClose={() => this.onClose()}
      >
        {this.renderComponents()}
      </PopupBottom>
    );
  }

  // 选择列表
  renderSelectedItem() {
    const { selectedValues } = this.state;
    const { prefixCls, itemTemplate, _crengine } = this.props;
    const { form, dataBind, childrens } = _crengine || {};

    if (!itemTemplate) {
      return null;
    }

    const { label, desc } = itemTemplate || {};
    const { childrens: subChildrens } = childrens[0];

    const formNode = () => {
      if (form && dataBind) {
        return form.getFieldDecorator(`${this.names}[list]`, {
          initialValue: selectedValues,
        })(
          <input type="hidden" />,
        );
      }

      return null;
    };

    if (selectedValues && Array.isArray(selectedValues) && selectedValues.length) {
      return (
        <div className={`${prefixCls}-selected ${prefixCls}-arrow`}>
          {
            selectedValues.map((item, key) => (
              <div
                className={`${prefixCls}-selected-item`}
                key={`item_${key}`}
                onClick={() => this.onEdit(key)}
              >
                <div className="selected-label">
                  <div
                    className="selected-delete"
                    onClick={(event) => this.onDelete(key, event)}
                  >
                    <i className="icon-delete" />
                    删除
                  </div>
                </div>
                <div className="selected-content">
                  <div className="selected-name">
                    {template(label, getItemLabel(item, subChildrens))}
                  </div>
                  <div className="selected-cert">
                    {template(desc, item)}
                  </div>
                </div>
              </div>
            ))
          }
          {formNode()}
        </div>
      );
    }

    return null;
  }

  renderAddButton() {
    const { selectedValues } = this.state;
    const { prefixCls, min, max, addLabel } = this.props;

    if (min && selectedValues.length < max) {
      const { label } = addLabel || {};

      return (
        <div
          className={`${prefixCls}-add`}
          onClick={() => this.openPopup()}
        >
          <i className="icon-add" />
          {label}
        </div>
      );
    }

    return null;
  }

  // 指定至少选择一个受益人
  renderAddTips() {
    const { selectedValues } = this.state;
    const { prefixCls, addTips, _crengine } = this.props;
    const { form, dataBind } = _crengine || {};

    if (addTips && selectedValues && Array.isArray(selectedValues) && selectedValues.length) {
      return null;
    }

    const formNode = () => {
      if (form && dataBind) {
        return form.getFieldDecorator(`${this.names}[help]`, {
          initialValue: '',
          rules: [{ required: true, message: addTips }],
        })(
          <input type="hidden" />,
        );
      }

      return null;
    };

    return (
      <div className={`${prefixCls}-add-tips`}>
        {addTips}
        {formNode()}
      </div>
    );
  }

  render() {
    const {
      prefixCls,
      value,
      defaultValue,
      addLabel,
      options,
    } = this.props;

    const { name } = addLabel || {};
    let initialValue = value || defaultValue;

    // 提交后转成{ value: 'other', list: [] }
    if (initialValue && isObject(initialValue)) {
      initialValue = initialValue.value;
    }

    // 选择指定受益人 & 添加受益人按钮
    if (!(options && name && name === initialValue)) {
      return null;
    }

    return (
      <div className={prefixCls}>
        {this.renderSelectedItem()}
        {this.renderAddButton()}
        {this.renderAddTips()}
        {this.renderPopup()}
      </div>
    );
  }
}

export default createForm({
  name: 'personAddPopup',
})(addPopup);
